import { Moment } from 'moment';
import { GeoLocation } from '../../common/common.types';
import { QuoteInvalidReason, QuoteParameter } from '../../pricing/price-matrix.types';
import { EventRecommendation } from '../recommendations/recommendation.types';

// todo: Rename in API and here.
export class Experience extends EventRecommendation {

}

export class ExperienceQuoteRequest {
	eventOn?: Moment | string;
	minAttendees?: number;
	maxAttendees?: number;
	minResources?: number;
	maxResources?: number;
	duration?: number;
	location?: GeoLocation;
	currencyCode?: string;
}

export class ExperienceQuote {
	isRangeQuote: boolean;
	isComplete: boolean;

	from: ExperienceQuotePart;
	to: ExperienceQuotePart;

	currencyCode?: string;
	missingParameters?: QuoteParameter[];
}

export class ExperienceQuotePart {
	isValid: boolean;
	amount?: number;
	invalidReason?: QuoteInvalidReason;
}
